import { useEffect, useState } from 'react';
import BONavigationButton from '@/components/back-office/BONavigationButton';
import axios from 'axios';
import { useRestaurantsContext } from '@/contexts/RestaurantContext';
import { toast } from 'react-toastify';

const BOHeader = ({
	instanceName,
	navigationRoute,
	text,
	hasButton = false,
	showToggle = true,
	withDescription = true,
	hasOtherButtons = false,
	otherButtons = null,
}) => {
	const role = JSON.parse(localStorage.getItem('role'));
	const email = JSON.parse(localStorage.getItem('user'))?.email;
	const [isEnabled, setIsEnabled] = useState(false);
	const { selectedRestaurant, setSelectedRestaurant } = useRestaurantsContext();

	useEffect(() => {
		if (selectedRestaurant) {
			setIsEnabled(selectedRestaurant.is_enabled);
		}
	}, [selectedRestaurant]);

	const handleClick = async () => {
		try {
			const response = await axios.patch(`/api/back-office/restaurants/${selectedRestaurant?.id}/edit-status`, {
				params: {
					email: email,
				},
			});

			if (response.status === 200) {
				setIsEnabled(response.data.restaurant.is_enabled);
				setSelectedRestaurant(response.data.restaurant);
			} else {
				console.error('Failed to update status');
			}
		} catch (error) {
			if (error.response.status === 400) {
				toast.info(error.response.data.message, {
					position: 'top-center',
					autoClose: 1800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					theme: 'colored',
				});
			}
		}
	};

	return (
		<div className="flex items-center justify-between">
			<div>
				<div>
					<p className="text-sm">Restaurant:</p>

					<div className="flex items-center gap-4">
						<h2 className="text-2xl">{instanceName ?? 'Aucun restaurant sélectionné'}</h2>

						{role === 'super-admin' && selectedRestaurant && showToggle && (
							<label className="relative inline-flex cursor-pointer items-center">
								<input
									id="switch-2"
									type="checkbox"
									className="peer sr-only"
									checked={isEnabled}
									onChange={(e) => handleClick(e)}
								/>
								<div
									className={`peer h-4 w-11 rounded-full border bg-slate-200 after:absolute after:-top-1 after:left-0 after:h-6 after:w-6 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] ${
										isEnabled
											? 'peer-checked:bg-primary peer-checked:after:translate-x-full peer-focus:ring-green-300'
											: ''
									}`}
								></div>
							</label>
						)}
					</div>
				</div>

				{withDescription && (
					<p className="text-xs w-4/5">
						Pour gérer les paramètres d’une autre instance, sélectionnez à gauche l’instance voulue
					</p>
				)}
			</div>

			{hasButton && <BONavigationButton navigationRoute={navigationRoute} text={text} />}
			{hasOtherButtons && (
				<div className="flex gap-4">
					{otherButtons &&
						otherButtons.map((button, index) => (
							<BONavigationButton key={index} navigationRoute={button.navigationRoute} text={button.text} />
						))}
				</div>
			)}
		</div>
	);
};

export default BOHeader;
